<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <h4 class="modal-card-title">
        {{title}}
      </h4>
      <div class="is-divider-vertical"></div>
      <i class="icon-close is-clickable" @click="cancel()"></i>
    </header>
    <section class="modal-card-body is-size-4">
      <p class="has-text-black-bis mb-5">
        {{description}}
      </p>
      <mf-multi-select  v-model="selectedProject"
        :options="options"
        titleLabel="Project"
        :multiple="false"
        :searchable="true"
        openDirection="below"
        label="name"
        track-by="_id"
        :allow-empty="false"
        :disabled="disableProject">
      </mf-multi-select>
      <mf-multi-select v-if="editWorkStep" v-model="selectedWorkstep"
        :options="allWorkSteps"
        titleLabel="Work Step"
        :multiple="false"
        :searchable="true"
        openDirection="below"
        label="name"
        track-by="_id"
        :allow-empty="false">
      </mf-multi-select>
      <mf-multi-select
        v-if="!invScreen && bulkQrPrint"
        v-model="qrLabelType"
        :options="qrLabelOptions"
        titleLabel="Print QR Label Type"
        :multiple="false"
        :searchable="false"
        openDirection="below"
        label="label"
        track-by="value"
        :allow-empty="false"
        @update:modelValue="setQrType($event)">
      </mf-multi-select>
      <o-checkbox
        v-if="bulkQrPrint"
        v-model="separatePdf"
        @update:modelValue="getSeparatePdf($event)"
      >
        <span  v-if="!invScreen" class="is-size-3 has-text-black-bis">
          Generate a separate PDF for each order</span>
        <span v-else class="is-size-3 has-text-black-bis">
          Generate a separate pdf for each item </span>
      </o-checkbox>
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <button class="button is-outlined" @click="cancel()">Cancel</button>
      <button v-if="!editWorkStep && !isBimplus" class="button has-background-black-bis"
              @click="select()"
              :disabled="disableSelect">Select</button>
      <button v-if="editWorkStep" class="button has-background-black-bis" :disabled="disableContinue" @click="selectWorkstep()" >Continue
           </button>
      <button v-if="isBimplus" class="button has-background-black-bis"
              @click="selectModel()"
              :disabled="!selectedProject">Select Model</button>
      </footer>
  </div>
</template>
<script>
import {
  reactive, toRefs, computed, onBeforeMount,
} from 'vue';
import { useStore } from 'vuex';
import { cloneDeep, filter, isEmpty, find } from 'lodash';

export default {
  props: {
    title: String,
    description: String,
    bulkQrPrint: Boolean,
    editWorkStep: Boolean,
    disableProject: Boolean,
    isBimplus: Boolean,
  },
  setup(props, { emit }) {
    const store = useStore();
    const state = reactive({
      selectedProject: null,
      labelType: '',
      qrLabelType: null,
      separatePdf: false,
      seperateForInvItem: false,
      selectedWorkstep: null,
      allWorkSteps: [],
      qrLabelOptions: [
        { label: 'Print Order QR Label', value: 'order' },
        { label: 'Print Item QR Label', value: 'item' },
        { label: 'Print Both Item and Order QR Label', value: 'both' }
      ],
    });
    const select = () => {
      emit('selected-project', state.selectedProject);
      emit('close');
    };
    const cancel = () => {
      emit('cancel');
      emit('close');
      store.commit('setSelectedWorkStep', '');
    };
    const selectWorkstep = () => {
      emit('select-workstep', state);
      store.commit('setSelectedWorkStep', state.selectedWorkstep);
      emit('close');
    };
    const selectModel = () => {
      emit('selected-model', state.selectedProject);
      emit('close');
    }
    const options = computed(() => {
      let bimProjects = filter(store.state.queryParams._projects, (project) => project.projectSettings[0].bimplusSync.models.length > 0 || project.projectSettings[0].bimplusSync.modelSource === 'SDS2');
      return props.isBimplus ? bimProjects : store.state.queryParams.projects;
    });
    const workstepOptions = computed(() => store.state.companyRuns);

    const setQrType = (selected) => {
      if (!selected) return;
      state.labelType = selected.value;
      store.dispatch('qrScan/setOrderLvlQr', state.labelType);
    };

    const disableContinue = computed(() => {
      if (!isEmpty(state.selectedProject) && state.selectedWorkstep) {
        return false;
      }
      return true;
    });
    const getSeparatePdf = (isChecked) => {
      state.separatePdf = isChecked;
      store.dispatch('qrScan/setSeperateQr', isChecked);
    };
    const invScreen = computed(() => {
      if (store.state.activeScreen === 'inventory' && props.bulkQrPrint) return true;
      if (props.bulkQrPrint) return false;
      return null;
    });
    const disableSelect = computed(() => {
      if (store.state.activeScreen === 'inventory') {
        return !state.selectedProject;
      }

      return !state.selectedProject || (props.bulkQrPrint && !state.qrLabelType);
    });
    onBeforeMount(async () => {
      const savedLabelType = store.state.qrScan.labelType;
      if (savedLabelType) {
        state.labelType = savedLabelType;
        state.qrLabelType = find(
          state.qrLabelOptions,
          { value: savedLabelType }
        );
      }

      if (props.editWorkStep) {
        await store.dispatch('getCompanyRuns');
        state.allWorkSteps = store.state.companyRuns;
      }
    });
    return {
      ...toRefs(state),
      options,
      select,
      cancel,
      setQrType,
      getSeparatePdf,
      invScreen,
      workstepOptions,
      selectWorkstep,
      disableContinue,
      selectModel,
      disableSelect
    };
  },
};
</script>

<style scoped>
  .modal-card-body {
    overflow: visible;
  }
</style>
